// @flow
import { commitMutation, graphql } from 'react-relay';

export const mutation = graphql`
  mutation CartV2UpdatePromoCodesMutation(
    $input: CartV2UpdatePromoCodesInput!
  ) {
    cartV2UpdatePromoCodes(input: $input) {
      cartV2 {
        id
        cartId
        autoShipEnabled
        autoShipIntervalUnit
        autoShipIntervalCount
        promoCodeSavings
        saleSavings
        canSubscribeForAutoShip
        discountQualifiedCartTotal
        subTotalPriceOfItems
        subTotalPriceOfItemsWithDiscount
        total
        totalSavings
        totalNumberOfItems
        subTotalPriceOfItems
        eventId
        eventHostFirstName
        event {
          id
          eventId
          trinityPartyType
        }
        promoCodes {
          id
          code
          promoDescription
          thresholds {
            discountAmount
            discountAmountEach
          }
        }
        wordPressCoupons {
          code
          couponDescription
          storeBalance
          yotpoCouponCode
        }
        wordPressCouponSavings
        entries(first: 1000) {
          edges {
            node {
              id
              sku
              productId
              quantity
              productName
              productURLslug
              productImageUrl
              wineBottleQuantity
              isWinePack
              priceOriginal
              priceSale
              priceDiscount
              discountEligible
              priceDiscountPercent
              hasQualifyingDiscount
            }
          }
        }
      }
    }
  }
`;

function commit({
  environment,
  promoCodes,
  noGiftCards,
  key,
  onCompleted,
  onError,
}) {
  return commitMutation(environment, {
    mutation,
    variables: { input: { promoCodes, noGiftCards, key } },
    onCompleted,
    onError,
  });
}

export default { commit };
